// @ts-nocheck
import React from 'react';
import { sx } from '../sx';
import { SEGMENTS, SELECT } from '../controls';
import CommitInput from './CommitInput';

const FIELD = `${SEGMENTS};align-items:center`;
const VALUE = `height:28px;border:none;background:none;padding:0;text-align:center;font-family:inherit;font-size:12px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--ink);outline:none`;
const UNIT = `flex:none;padding-right:12px;font-size:12px;color:var(--ink-3);white-space:nowrap`;

function StepButton({ label, symbol, enabled, onClick }) {
  return (
    <button
      type="button"
      className="gmHover"
      aria-label={label}
      disabled={!enabled}
      onClick={onClick}
      style={sx(`flex:none;width:28px;height:28px;border:none;background:none;font-family:inherit;font-size:15px;line-height:1;color:${enabled ? '#0052CD' : '#C8D4EA'};cursor:${enabled ? 'pointer' : 'default'}`)}
      data-hover={enabled ? 'background:#EAF1FD' : ''}
    >
      {symbol}
    </button>
  );
}

export default function CohortRuleFields({ f }: { f: any }) {
  return (
    <div style={sx(`display:flex;align-items:center;gap:6px;flex-wrap:nowrap`)}>
      <select aria-label="forecast method" value={f.method} disabled={f.disabled} onChange={f.onMethod} style={sx(`${SELECT};max-width:200px;cursor:${f.disabled ? 'default' : 'pointer'}`)}>
        {(f.methodOpts || []).map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      {f.isFixed ? (
        <div className="gmField" style={sx(`${FIELD};padding-left:8px`)}>
          <CommitInput ariaLabel="fixed repurchase percent" disabled={f.disabled} value={f.pctValue} onCommit={f.onPct} style={sx(`${VALUE};width:42px`)} />
          <span style={sx(UNIT)}>%</span>
        </div>
      ) : f.hideN ? null : (
        <div className="gmField" title={f.nHint} style={sx(FIELD)}>
          <StepButton label={'fewer ' + f.nLabel} symbol="−" enabled={f.canDec} onClick={f.onDec} />
          <CommitInput ariaLabel={'forecast method ' + f.nLabel} disabled={f.disabled} value={f.nValue} onCommit={f.onN} style={sx(`${VALUE};width:26px`)} />
          <StepButton label={'more ' + f.nLabel} symbol="+" enabled={f.canInc} onClick={f.onInc} />
          <span style={sx(UNIT)}>{f.nLabel}</span>
        </div>
      )}
    </div>
  );
}
